import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { FormStepComponentProps } from 'components/Forms/MultiStepForm';

export type BuyersCreateFormContact = {
  email: string;
  phoneNumber: string;
  firstName?: string;
  lastName?: string;
};

export type BuyersCreateForm = {
  formName: 'buyerCreateForm';
  name: string;
  acceptedMaterials: string[];
  postalCode: string;
  city: string;
  addressLine: string;
  phoneNumber: string;
  contact: BuyersCreateFormContact;
};

export type BuyersCreateContext = {};

export type BuyersCreateStepProps = FormStepComponentProps<BuyersCreateForm, BuyersCreateContext>;

const useBuyerCreateStepStyles = makeStyles({
  form: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    paddingBottom: '2.5em',
  },
  fieldLine: {
    marginTop: 8,

    '& > div': {
      minWidth: 470,
    },

    '& span': {
      fontSize: 18,
      marginBottom: 5,
    },
  },
  selectWithError: {
    '& > div': {
      width: '100%',
    },
  },
  switch: {
    marginTop: 20,
    marginBottom: 0,
  },
  sharedLine: {
    display: 'flex',
    justifyContent: 'space-between',

    '& > div': {
      width: 214,
    },
  },
});

export const useBuyerCreateStepsHooks = () => ({
  t: useTranslation().t,
  classes: useBuyerCreateStepStyles(),
});
